{
  "attachAria": "Прикріпити файл",
  "emptyHint": "Опишіть питання — підтримка відповість тут",
  "emptyTitle": "Повідомлень поки немає",
  "fileOpenAria": "Відкрити вкладення",
  "logAria": "Листування за зверненням",
  "newMessages": "Нові повідомлення",
  "placeholder": "Напишіть повідомлення…",
  "placeholderDisabled": "Повідомлення тимчасово недоступні",
  "previewAria": "Переглянути вкладення",
  "previewCloseAria": "Закрити перегляд",
  "removeAttachmentAria": "Видалити файл",
  "retry": "Повторити",
  "screenshotAria": "Зробити скриншот",
  "seen": "Прочитано",
  "sendAria": "Надіслати повідомлення",
  "sendFailed": "Не вдалося надіслати повідомлення",
  "sending": "Надсилається…",
  "student": "Студент",
  "supportName": "Підтримка Skyeng",
  "today": "Сьогодні",
  "yesterday": "Учора",
  "you": "Ви"
}
